import { defaultPathForRole } from "../auth/packageAccess";
import { hasAgentAccess, hasBrokerAccess, hasClientAccess } from "../auth/authService";

/**
 * Primary header navigation — each signed-in role sees only its platform links.
 * Guests retain browse access to buyer and seller journeys (launch standard).
 */
export function primaryNavLinks(session) {
  const role = session?.role;

  if (!role) {
    return [
      { to: "/", label: "Home", allow: true },
      { to: "/dashboard", label: "Dashboard", allow: true },
      { to: "/start", label: "Buyer Journey", allow: true },
      { to: "/seller/home", label: "Seller Home", allow: true },
      { to: "/notices", label: "Notices", allow: true },
    ];
  }

  if (role === "admin") {
    return [
      { to: "/admin", label: "Admin Desk", allow: true },
      { to: "/dashboard", label: "Client Hub", allow: true },
      { to: "/start", label: "Buyer Preview", allow: true },
      { to: "/seller/home", label: "Seller Preview", allow: true },
      { to: "/notices", label: "Notices", allow: true },
    ];
  }

  if (role === "buyer") {
    return [
      { to: "/start", label: "Buyer Dashboard", allow: true },
      { to: "/client/messages", label: "Messages", allow: true },
      { to: "/notices", label: "Notices", allow: true },
    ];
  }

  if (role === "seller") {
    return [
      { to: "/seller/home", label: "Seller Dashboard", allow: true },
      { to: "/client/messages", label: "Messages", allow: true },
      { to: "/notices", label: "Notices", allow: true },
    ];
  }

  if (hasAgentAccess(role)) {
    return [
      { to: defaultPathForRole(role), label: "Agent Desk", allow: true },
      { to: "/account", label: "Account", allow: true },
      { to: "/notices", label: "Notices", allow: true },
    ];
  }

  if (hasBrokerAccess(role)) {
    return [
      { to: defaultPathForRole(role), label: "Broker Desk", allow: true },
      { to: "/account", label: "Account", allow: true },
      { to: "/notices", label: "Notices", allow: true },
    ];
  }

  return [{ to: "/", label: "Home", allow: true }];
}

export function clientMessagesPath(role) {
  if (hasClientAccess(role)) return "/client/messages";
  if (role === "seller") return "/seller/login";
  return "/login";
}
